import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup } from "@angular/forms";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import Swal from "sweetalert2";

@Component({
  selector: "app-settings-form-modal",
  templateUrl: "./settings-form-modal.component.html",
  styleUrls: ["./settings-form-modal.component.css"],
})
export class SettingsFormModalComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  settingsForm: FormGroup;
  backendValidationErrors = null;
  constructor(
    private modalService: NgbModal,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    public globalService: GlobalService
  ) {}
  get settingsFormCtrl() {
    return this.settingsForm.controls;
  }
  async ngOnInit() {
    this.settingsForm = this.fb.group({
      auto_video_edit: [false],
      student_dashboard_section_filter: [false],
      auto_approval: [false],
      days: ["3"],
    });

    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
    };
    const getSettings: any = await this.globalService.get(
      "classVideoDetail/vendor-details",
      filter,
      true
    );
    if (getSettings["status"] == 200) {
      this.settingsForm.controls["auto_video_edit"].patchValue(
        getSettings["content"]["auto_video_edit"] === 1 ? true : false
      );
      this.settingsForm.controls["student_dashboard_section_filter"].patchValue(
        getSettings["content"]["student_dashboard_section_filter"] === 1 ? true : false
      );
      this.settingsForm.controls["auto_approval"].patchValue(
        getSettings["content"]["auto_approval"] === 1 ? true : false
      );
      this.settingsForm.controls["days"].patchValue(
        getSettings["content"]["days"]
      );
    }
    this.spinner.hide();
  }

  modalClose(): void {
    this.modalService.dismissAll();
  }

  async onClickUpdateSettings() {
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      auto_video_edit: this.settingsForm.value["auto_video_edit"] ? '1' : '0',
      student_dashboard_section_filter: this.settingsForm.value["student_dashboard_section_filter"] ? '1' : '0',
      auto_approval: this.settingsForm.value["auto_approval"] ? '1' : '0',
      days: this.settingsForm.value["days"],
    };
    const updateSettings: any = await this.globalService.update(
      "classVideoDetail/update-vendor-settings",
      filter,
      false
    );
    if (updateSettings["status"] == 200) {
      Swal.fire("Success!", updateSettings["message"], "success");
      this.backendValidationErrors = null;
      this.spinner.hide();
      this.modalClose();
    } else if (updateSettings["status"] === 422) {
      this.backendValidationErrors = updateSettings.error["content"];
      this.spinner.hide();
    } else {
      this.modalClose();
      this.backendValidationErrors = null;
    }
  }
  onClickResetSettings() {
    this.backendValidationErrors = null;
    this.settingsForm.controls["auto_video_edit"].patchValue(false);
    this.settingsForm.controls["student_dashboard_section_filter"].patchValue(false);
    this.settingsForm.controls["auto_approval"].patchValue(false);
    this.settingsForm.controls["days"].patchValue(false);
  }
}
